import { AutocompleteInfo, EnvData } from "./types";
import useData from "./useData";

export default function useExampleAuthorize(selectedEnv: EnvData | null) {
  const { data: autocompleteInfo } = useData<AutocompleteInfo>(
    () =>
      selectedEnv &&
      `/web/environment/${selectedEnv.pub_id}/api/autocomplete_info/`
  );

  const actorId = "alice";
  const resourceId = "foo";

  let actorType = "User";
  let permission = "read";
  let resourceType = "Repository";
  let defaultSuggestion = true;

  if (autocompleteInfo) {
    let actor: string | null = null;
    if (
      autocompleteInfo.actors.length > 0 &&
      autocompleteInfo.actors[0].kind === "symbol"
    ) {
      if (
        autocompleteInfo.actors.some(
          (actor) => actor.kind === "symbol" && actor.value === "User"
        )
      ) {
        // default to User if it's an option
        actor = "User";
      } else {
        actor = autocompleteInfo.actors[0].value;
      }
    }

    if (actor && autocompleteInfo.suggestions) {
      const permissionSuggestion =
        autocompleteInfo.suggestions["has_permission"];
      if (permissionSuggestion) {
        for (const suggestion of permissionSuggestion) {
          if (
            suggestion.length === 3 &&
            suggestion[0].kind === "symbol" &&
            suggestion[0].value === "Actor" &&
            suggestion[1].kind === "literal" &&
            suggestion[2].kind === "symbol"
          ) {
            actorType = actor;
            permission = suggestion[1].value;
            resourceType = suggestion[2].value;
            defaultSuggestion = false;
          }
        }
      }
    }
  }

  return {
    actorId,
    resourceId,
    actorType,
    permission,
    resourceType,
    defaultSuggestion,
  };
}
